// extracted by mini-css-extract-plugin
module.exports = {"dateContainer":"CreditCardExpiryDate_dateContainer__12FLB","date":"CreditCardExpiryDate_date__3vY65"};